import type { SxProps, Theme } from '@mui/material';
import { black, white, green60 } from '../../../colors';

export const DRAWER_WIDTH = 382;

export const drawerSx: SxProps<Theme> = {
    width: DRAWER_WIDTH,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
        width: DRAWER_WIDTH,
        boxSizing: 'border-box',
        backgroundColor: '#FFFFFF',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
};

export const drawerBackdropSx: SxProps<Theme> = {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    overflow: 'hidden',
};

export const chipSx = (isSelected: boolean): SxProps<Theme> => ({
    verticalAlign: 'top',
    boxSizing: 'border-box',
    flexShrink: 0,
    p: 0,
    maxWidth: '47%',
    '& .MuiChip-label': {
        width: '100%',
        textAlign: 'left',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        lineHeight: 1.5,
    },
    '& .MuiChip-deleteIcon': {
        marginLeft: 'auto',
        marginRight: '-3px',
        fontSize: '16px',
        color: isSelected ? '#ECECEC' : black,
        '&:hover': { color: isSelected ? '#ECECEC' : black },
        '&.Mui-focusVisible': { outline: 'none' },
    },
    '&:hover, &.MuiChip-clickable:hover, &.MuiChip-clickable:focus-visible': {
        backgroundColor: isSelected ? green60 : '#ECECEC',
        color: isSelected ? white : 'text.primary',
        borderWidth: 1,
    },
    backgroundColor: isSelected ? green60 : '#ECECEC',
    color: isSelected ? white : '#0A0A0A',
    borderWidth: 1,
});

export const accordionSummaryExpandedSx: SxProps<Theme> = {
    pl: 0,
    height: 30,
    mt: 0,
    py: 0,
    '&.Mui-expanded': { maxHeight: 32, minHeight: 32, mt: 0 },
    '&.MuiAccordionDetails-root': { p: 0 },
};
